import type { TransferPlan } from '../api/types'

export function getTransferRemainingAmount(plan: TransferPlan): number {
  if (plan.type === 'unknown') return 0
  // The server stores amounts with four decimal places.
  return Number((plan.amount - plan.resolvedAmount).toFixed(4))
}

export function getTransferSettlementError(plan: TransferPlan, input: string): string | null {
  if (plan.type === 'unknown') return '이 거래는 정산할 수 없습니다.'
  const remaining = getTransferRemainingAmount(plan)
  if (!Number.isFinite(remaining) || remaining <= 0) return '이미 정산이 완료된 거래입니다.'
  const amount = Number(input)
  if (!input.trim() || !Number.isFinite(amount) || amount <= 0) return '유효한 정산 금액을 입력해주세요.'
  if (amount !== remaining) {
    return `정산 금액은 잔여액 ${remaining.toLocaleString('ko-KR', { maximumFractionDigits: 4 })} ${plan.currencyCode}와 정확히 일치해야 합니다.`
  }
  return null
}
